import { useNavigate } from 'react-router-dom';
import { LoginForm } from '@/pages/auth/LoginForm';
import { getPostLoginPath } from '@/utils/moduleScope';
import {
  isFattahOneProductSelectionRequired,
  isPlatformOnboardingRequired,
} from '@/modules/onboarding/onboardingState';
import { resolveOwnerHomePath } from '@/utils/moduleAccess';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { clearAuth } from '@/store/authSlice';
import { notify } from '@/core/toast/notify';

export function FattahLoginPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <LoginForm
      showRegisterLink
      onLoginSuccess={(result) => {
        if (result.masterAdmin) {
          dispatch(clearAuth());
          notify.error('Platform operators must use the master console login URL.');
          return;
        }
        if (isFattahOneProductSelectionRequired()) {
          navigate('/onboarding/products', { replace: true });
          return;
        }
        if (isPlatformOnboardingRequired()) {
          navigate('/onboarding', { replace: true });
          return;
        }
        if (result.entryModule) {
          const home = getPostLoginPath(
            result.entryModule as never,
            resolveOwnerHomePath(result.enabledModules ?? []),
          );
          navigate(home, { replace: true });
          return;
        }
        navigate(resolveOwnerHomePath(result.enabledModules ?? []), { replace: true });
      }}
    />
  );
}
